import mapboxGl from "mapbox-gl"
import { type ComponentProps, memo } from "react"

import { MAPBOX_ACCESS_TOKEN } from "../constants"
import { MapStyle } from "../enums"
import { mapStyleSpecifications } from "../mappings"
import { Map as MapboxMap } from "./memo"

interface MapProps extends Omit<
	ComponentProps<typeof MapboxMap>,
	"mapboxAccessToken" | "reuseMaps" | "renderWorldCopies" | "mapStyle" | "projection"
> {
	mapStyle: MapStyle
}

export const Map = memo<MapProps>((props) => {
	const { children, mapStyle, ...rest } = props

	return (
		<MapboxMap
			mapboxAccessToken={MAPBOX_ACCESS_TOKEN}
			// reuseMaps={true}
			renderWorldCopies={false}
			projection="globe"
			mapStyle={mapStyleSpecifications[mapStyle]}
			mapLib={mapboxGl}
			{...rest}
		>
			{children}
		</MapboxMap>
	)
})
Map.displayName = "Map"
